<div class="form-group" [class.has-error]="!!errors()">
  <span [class.input--filled]="!!formGroup.get('groupedKey')?.value">
    <label [htmlFor]="controlName() + '_key'" class="control-label">
      {{ schemaTranslations()?.getFieldTranslation(controlName()) || 'Region' }}
    </label>
    <select [formControl]="$any(formGroup.get('groupedKey'))"
            class="form-control"
            [id]="controlName() + '_key'">
      <option value="">{{ 'generic.default_select_value' | translate }}</option>
      @for (key of groupedKeys; track key) {
        <option [value]="key">
          {{ schemaTranslations()?.getEnumTranslation(controlName(), key) || key }}
        </option>
      }
    </select>
  </span>
  @if (!!groupedValues) {
    <span
        [class.input--filled]="!!formGroup.get('groupedValue')?.value">
      @if (!schemaTranslations()?.getFieldTranslation(controlName())) {
        <label
            [htmlFor]="controlName() + '_value'"
            class="control-label">
          {{ 'Favorittbutikk' }}
        </label>
      }
      <select [formControl]="$any(formGroup.get('groupedValue'))"
              class="form-control"
              [id]="controlName() + '_value'"
              [required]="required">
        <option value="">{{ 'generic.default_select_value' | translate }}</option>
        @for (value of groupedValues; track value) {
          <option [value]="value">
            {{ schemaTranslations()?.getEnumTranslation(controlName(), value) || value }}
          </option>
        }
      </select>
    </span>
  }
</div>
